export const isRecommended = (str: string) =>
	str.toLowerCase().includes('recommended');

export const getAlphaOrder = (prev: string, next: string) =>
	prev.localeCompare(next);

export const byLabel = (a: { label: string }, b: { label: string }) =>
	a.label.localeCompare(b.label);
